import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../assets/Flourish.module.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { OneIdentityService } from '../service/oneIdentityService';
import { logComponentError } from '../service/logging';
const { FORGOT_PASSWORD_URL, LOGIN_URL} = require('../helper/application-conf').default;
const { DefaultStyle, IconWarning, dlsBrightBlue, Anchor } = require('@americanexpress/dls-react');


export const ErrorPage: React.FC<any> = (props: any) => {
  const { t } = useTranslation();
  const location = useLocation();
  const errorText = location.state?.errorText.message;
  const expiredStatus = location.state?.errorText.status;
  const expiredMobileVerficationStatus = location.state?.errorText.mobileVerificationStatus;
  const navigate = useNavigate();
  const [width, setWidth] = useState<number>(window.innerWidth);
  const oneIdentityService = new OneIdentityService();
  const SITENAME = window.location.pathname.split('/')[2];

  const checkDynamicError = (errorText: string) => {
    return errorText !== null && errorText !== undefined;
  };

  const checkExpiredStatus = (expiredStatus: string) => {
    return expiredStatus !== null && expiredStatus !== undefined;
  };

  const checkMobileVerificationStatus = (expiredMobileVerficationStatus: string) => {
    return expiredMobileVerficationStatus !== null && expiredMobileVerficationStatus !== undefined;
  };

  const navigateHandler = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if(props.oneIdentityEnabled) {
       event.preventDefault();
       window.location.href = `${oneIdentityService.oneIdentityURL()}?DestPage=${window.location.origin}/${SITENAME}/home`
    }
    else {
        navigate(LOGIN_URL);
    }
  };

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

  const isMobile = width <= 600;
  
  return (
      <div className='margin-4-b'>
          <DefaultStyle/>
          <div className={`container ${styles.noFilter}`}>
              {checkDynamicError(errorText) ?
                  <div className={`container ${styles.noFilter}`}>
                      {checkExpiredStatus(expiredStatus) || checkMobileVerificationStatus(expiredMobileVerficationStatus) ?

                          <div className="pad-4-t">
                              <div className="text-align-center body-3 margin-2-t pad-4-t">
                                  <IconWarning aria-label="warning-icon" size="lg" role="button" theme={dlsBrightBlue}/>
                              </div>
                              <h5 className="text-align-center heading-5 pad-4-t">
                                  {t('errors.expired_link')}
                              </h5>
                              <div className="row">
                                  <div className="col-md-offset-3 col-md-3  margin-2-t pad-4-t">
                                      <p className='heading-4 pad-1-b'>{t('errors.point_one')}</p>
                                      <ul className='text-font-size-1'>
                                          <li>{t('errors.text_1')}</li>
                                          <li>{t('errors.text_2')}</li>
                                          <li>{t('errors.text_3')}</li>
                                      </ul>
                                  </div>
                                  {checkExpiredStatus(expiredStatus) || props.oneIdentityEnabled ?
                                      <div className="col-md-4 margin-2-t pad-4-t">
                                          <p className='heading-4'>{t('errors.point_two')}</p>
                                          <ul className='text-font-size-1 pad-1-t'>
                                              <li>
                                                  <Anchor id="login-link" inline='true' className="text-decoration-none"
                                                          onClick={navigateHandler}>
                                                      {t('multi_step_tracker.login')}
                                                  </Anchor>
                                              </li>
                                              { !props.oneIdentityEnabled &&
                                              <li>
                                                  <Anchor id="forgot-link" inline='true'
                                                          className="text-decoration-none"
                                                          onClick={() => {
                                                              navigate(FORGOT_PASSWORD_URL);
                                                          }}>
                                                      {t('multi_step_tracker.forgotpassword')}
                                                  </Anchor>
                                              </li>
                                              }
                                          </ul>
                                      </div>
                                      :
                                      <div></div>
                                  }
                              </div>
                          </div>
                          :
                          <>
                              <div className="row text-align-center pad-4-t">
                                  <p className="col-md-offset-3 col-md-6 body-3 margin-2-t pad-4-t">{errorText}</p>
                              </div>
                          </>
                      }
                  </div>
                  :
                  <>
                      <div className="row text-align-center pad-4-tb">
                          <h5 className="col-md-offset-3 col-md-6 heading-5 pad-4-t">
                              {t('errors.error_boundary_header')}
                          </h5>
                      </div>
                      <div className="row text-align-center">
                          <p className="col-md-offset-3 col-md-6 body-3">
                              {t('errors.error_boundary_note')}
                          </p>
                      </div>
                  </>
              }
              <div className={styles.flourishParent}></div>
          </div>
          <div className={`${!isMobile ? styles.flourish : styles.flourishMobile} ${props.oneIdentityEnabled ? styles.flourishTop: ''}`}/>
      </div>
  );
};

class ErrorBoundary extends React.Component {
  /* eslint-disable-next-line react/state-in-constructor -- TBD */
  state: { hasError: false };

  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: { componentStack?: string }) {
    // Forward render-time errors to ELF before showing the fallback UI.
    logComponentError(error, info);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <ErrorPage />;
    }

    /* eslint-disable-next-line no-extra-parens -- TBD */
    return (this.props as any).children;
  }
}

export default ErrorBoundary;
